import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { IntlProvider as IP } from 'react-intl';

import { BackButton } from './ActionButton';
import ButtonCollection from './ButtonCollection.js';
import SaveButton from './SaveButton';

const BuilderSidebar = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let has_errors = props?.errors ?? false;
	let has_changes = props?.has_changes ?? false;

	// maybe the "errors" is only an empty object, so we assure it has at least one element:
	if(has_errors !== false && typeof(has_errors) == 'object' && Object.keys(has_errors).length == 0) has_errors = false;

	const only_sidebar = props?.only_sidebar ?? false;
	const has_bottom_buttons = (props.backButton != undefined || props.onSave != undefined) ? true : false;
	const extra_classes = props?.extra_classes ?? false;

	const custom_button = props?.custom_button ?? false;
	const display_bottom_buttons = props?.display_bottom_buttons ?? (has_bottom_buttons || custom_button);

	const locales = window?.promo_locales || window.start_locales;
	const actions_classes = props?.actions_classes ?? false;

	let classes = ['builder_sidebar', 'not_awesome', 'main_bg'];
	if(display_bottom_buttons) classes.push('with_floating_actions');
	if(only_sidebar) classes.push('only_sidebar');
	if(extra_classes !== false) classes.push(extra_classes);

	let label_button = "Save";
	if(has_errors) label_button = "Errors";

	return (
		<IP locale={locales.locale} messages={locales.messages}>
			<aside class={classes.join(" ")} aria-label='sidebar options'>
				<div class={`sidebar_contents ${props?.sidebar_classes ?? ''}`} style={props.style}>
					{props.children}
				</div>

				{(display_bottom_buttons) && (
					<ButtonCollection _class={{other:`floating_sidebar_actions ${(actions_classes !== false) ? ` ${actions_classes}` : ''}`}}>
						{(props.onSave != undefined) && (
							<SaveButton
								disabled={has_errors}
								color={(has_errors) ? 'red' : null}
								icon={(has_errors) ? 'knk-alert' : null}
								onClick={(e, cb) => props.onSave(cb)}
							>{label_button}</SaveButton>
						)}

						{(props.backButton != undefined) && (
							<BackButton
								_href={props.backButton.link}
								onClick={props.backButton.onClick}
								autotranslate={false}
							>{props?.backButton.text ?? null}</BackButton>
						)}

						{(custom_button) && (
							<div class="in_top">{custom_button}</div>
						)}
					</ButtonCollection>
				)}
			</aside>
		</IP>
	)
}

export default injectIntl(BuilderSidebar);